export default __webpack_public_path__ + "static/media/phone1.ead7dc88.svg";